import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    MenuItem,
    Select,
    TextField,
    Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const InsuranceAgentTrainingDemo = () => {
    const [country, setCountry] = useState("us");
    const [selectedQueue, setSelectedQueue] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [priceB, setPriceB] = useState("150");

    const femaleOptions = {
        betty_smith: "Betty Smith (The \"Easy\" Lead)",
        margaret_lee: "Margaret Lee (The \"I'm Already Covered\")",
        brenda: "Brenda (The \"I'll Think About It\" Procrastinator)",
        gloria: "Gloria (The \"Distracted\" Lead)"
    };

    const maleOptions = {
        david_johnson: "David Johnson (The \"Hurry & Cremation\" Combo)",
        arthur_smith: "Arthur Smith (The \"Decision-Maker\" Objection)",
        robert_jones: "Robert Jones (The \"Skeptical & Annoyed\" Lead)",
        frank: "Frank (The \"Fixed Income / Can't Afford It\")",
        george: "George (The \"My Kids Will Pay\")",
        tom: "Tom (The \"Healthy & In Denial\")"
    };

    // Combine all options for display
    const friendlyNames = { ...femaleOptions, ...maleOptions };

    // Agent IDs
    const femaleAgentId = "agent_af5e27b1d6198a8c96a3921f47";
    const maleAgentId = "agent_cb0619bf546ebf1660b6fbf35f";

    const handleSubmit = async (event) => {
        event.preventDefault();

        const fromNumber = "18508883579";
        const baseUrl = "https://initiateretellcall-655075094783.us-central1.run.app";
        
        // Determine which agent to use based on selected queue
        const agent_id = femaleOptions[selectedQueue] ? femaleAgentId : maleAgentId;
        
        // Default dynamic variables
        const human_agent_id = "0ho90QkFDmsLuKGZ4iAv";
        const lead_id = "FSHpnvJoxO7iFKP63BxF";
        const human_agent_first_name = "Marco";
        const human_agent_company_name = "Company";
        const lead_tz = "America/Chicago";
        const human_agent_tz = "America/New_York";
        
        const lead_first_name = "TrainingAgent";
        const lead_state = "TX";
        const lead_type = selectedQueue;
        const lead_type_friendly_name = friendlyNames[lead_type] || lead_type;
        const to_number = phoneNumber;

        // Build URL with base parameters
        let url = `${baseUrl}?lead_id=${lead_id}&lead_first_name=${lead_first_name}&from_number=${fromNumber}&agent_id=${agent_id}&human_agent_id=${human_agent_id}&human_agent_company_name=${human_agent_company_name}&to_number=+${to_number}&lead_state=${lead_state}&human_agent_first_name=${human_agent_first_name}&lead_type=${lead_type}&human_agent_tz=${human_agent_tz}&lead_tz=${lead_tz}&lead_type_friendly_name=${lead_type_friendly_name}`;

        // Add price_b only for brenda queue
        if (lead_type === "brenda") {
            url += `&price_b=${priceB}`;
        }

        console.log(`Starting call with URL ${url}`);

        await axios
            .request(url, {
                method: "GET",
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => window.alert("Call initiated successfully!"));
    };

    return (
        <div className="full-page-background">
            <Grid item xs={12} md={7}>
                <Container className="App" maxWidth="sm">
                    <img src={logo} className="App-logo" alt="logo" />
                    <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                        <h1 style={{
                            color: '#FFFFFF',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            margin: '1rem',
                        }}>
                            Insurance Agent Training Demo
                        </h1>
                        <div style={{
                            height: '4px',
                            width: '100px',
                            background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
                            margin: '0 auto',
                            borderRadius: '2px'
                        }}></div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <Select
                                value={selectedQueue}
                                onChange={(e) => {
                                    setSelectedQueue(e.target.value);
                                }}
                                displayEmpty
                                required
                                sx={{
                                    backgroundColor: "white",
                                    borderRadius: "4px",
                                    textAlign: "left",
                                }}
                            >
                                <MenuItem value="" disabled>
                                    <span style={{ color: '#999' }}>Select a lead persona</span>
                                </MenuItem>
                                {Object.entries(femaleOptions).map(([key, label]) => (
                                    <MenuItem key={key} value={key}>
                                        {label}
                                    </MenuItem>
                                ))}
                                {Object.entries(maleOptions).map(([key, label]) => (
                                    <MenuItem key={key} value={key}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {selectedQueue === "brenda" && (
                                <TextField
                                    margin="dense"
                                    label="Quote"
                                    type="text"
                                    fullWidth
                                    sx={{
                                        color: "white",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                    }}
                                    value={priceB}
                                    onChange={(e) => setPriceB(e.target.value)}
                                    required
                                />
                            )}
                            <h3 style={{
                                color: '#FFFFFF',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                margin: '16px 0 0 0',
                                textAlign: 'left'
                            }}>
                                Your Number
                            </h3>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                                <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                                    <Select
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        sx={{
                                            backgroundColor: "white",
                                            borderRadius: "4px",
                                            height: "56px",
                                        }}
                                        required
                                    >
                                        <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                                        <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                                    <PhoneInput
                                        country={country}
                                        value={phoneNumber}
                                        disableDropdown={true}
                                        disableCountryGuess={true}
                                        onChange={setPhoneNumber}
                                        enableLongNumbers={true}
                                        placeholder="Enter your phone number"
                                        inputStyle={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            height: "56px",
                                            borderRadius: "4px",
                                            border: "1px solid #ced4da",
                                        }}
                                        required
                                    />
                                </Box>
                            </Stack>
                            <Button
                                className="callBtn"
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{
                                    background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                                    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                                    color: 'white',
                                    height: '56px',
                                    padding: '0 30px',
                                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                                        background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                                    },
                                }}
                            >
                                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                                    Click here to receive the DEMO call
                                </h2>
                                <div style={{ width: "20px" }} />
                                <Call className="callIcon" />
                            </Button>
                            <div style={{
                                // Bubble Container Styles
                                backgroundColor: '#eaf2fa',
                                padding: '16px',
                                borderRadius: '8px',
                                border: '1px solid #d0e0f0',

                                // Flexbox for alignment
                                display: 'flex',
                                alignItems: 'center', // Vertically centers the icon and text
                                gap: '12px'           // Adds space between the icon and text
                            }}>
                                {/* Icon */}
                                <span style={{ fontSize: '24px' }}>ℹ️</span>

                                {/* Text Content */}
                                <p style={{
                                    margin: 0, // Resets default paragraph margin
                                    textAlign: 'left',
                                    color: '#333',
                                    lineHeight: '1.5',
                                    fontSize: '14px'
                                }}>
                                    After clicking to receive the DEMO call, you will receive a call from the following number:
                                    <b style={{ color: '#005a9c' }}> +1 (850) 888-3579</b>
                                </p>
                            </div>
                        </Stack>
                    </form>
                </Container>
            </Grid>
        </div>
    );
};

